import React from 'react';
import './TimeSlots.css';

/**
 * Time slots grid. Booked or past slots are hidden (per spec).
 *
 * @param {Array} slots    [{ time, label, available, booked, past }]
 * @param {string} value   currently-selected time (HH:MM)
 * @param {fn} onChange    (time) => void
 * @param {boolean} loading
 */
export default function TimeSlots({ slots = [], value, onChange, loading }) {
  if (loading) {
    return (
      <div className="time-slots" aria-busy="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="time-slot time-slot--skeleton" aria-hidden="true" />
        ))}
      </div>
    );
  }

  const visible = slots.filter((s) => s.available);

  if (!visible.length) {
    return (
      <div className="time-slots__empty">
        No times available for this day. Try another date.
      </div>
    );
  }

  return (
    <div
      className="time-slots"
      role="radiogroup"
      aria-label="Available times"
    >
      {visible.map((s) => {
        const selected = s.time === value;
        return (
          <button
            key={s.time}
            type="button"
            role="radio"
            aria-checked={selected}
            className={`time-slot ${selected ? 'time-slot--selected' : ''}`}
            onClick={() => onChange(s.time)}
          >
            {s.label}
          </button>
        );
      })}
    </div>
  );
}